module.exports = __webpack_public_path__ + "static/media/credit-card.8f1cfd70.svg";